import React, { useEffect, useState } from "react";
import RateRestaurant from "../../commonComponents/rate-one-to-five/rateRestaurant";
import "./ordersHistory.scss";

function MyOrdersHistory() {
  const [ordersHistory, setOrdersHistory] = useState(null);
  const [showOrderSummaries, setShowOrderSummaries] = useState([]);

  useEffect(() => {
    const getOrdersHistory = async () => {
      try {
        const response = await fetch(
          "https://femez.onrender.com/API/user/getOrdersHistory",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          console.log(data.ordersHistory);

          setOrdersHistory(data.ordersHistory);
        } else {
          console.error("Failed to fetch orders history");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    getOrdersHistory();
  }, []);

  return (
    <div className="orders-history-container">
      <h2>My Orders History</h2>
      {ordersHistory ? (
        ordersHistory.length > 0 ? (
          <ul>
            {ordersHistory
              .sort((a, b) => new Date(b.orderTime) - new Date(a.orderTime))
              .map((order, index) => (
                <div key={index} className="notification-details-container">
                  <div className="notification-details">
                    <div className="restaurant-name-container">
                      Ordered from the restaurant:
                      <p className="restaurant-name"> {order.restaurantName}</p>
                    </div>
                    <div className="order-time-container">
                      Order placed at:
                      <p className="order-time">{order.orderTime}</p>
                    </div>
                    <RateRestaurant restaurantId={order.restaurantId} />
                    <div
                      className="view-details"
                      onClick={() =>
                        setShowOrderSummaries((prevSummaries) =>
                          prevSummaries.includes(index)
                            ? prevSummaries.filter((i) => i !== index)
                            : [...prevSummaries, index]
                        )
                      }
                    >
                      View order summary
                    </div>
                    {showOrderSummaries.includes(index) && (
                      <div className="order-dishes-container">
                        <p className="title">Order summary</p>
                        {order.orderSummary.map((item, index) => (
                          <div key={index} className="order-dishes">
                            <p>
                              {item.dishes[0].dishName}({item.count})
                            </p>
                            <p key={index}>
                              {item.dishes[0].dishPrice * item.count} €
                            </p>
                          </div>
                        ))}
                        <div className="order-dishes-total-price">
                          <p>Total order price:</p>{" "}
                          <p className="total-price">
                            {order.orderTotalPrice} €
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </ul>
        ) : (
          <p className="no-orders">You don't have any orders yet.</p>
        )
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default MyOrdersHistory;
